// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/base-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Fees } from './Fees';
import {
    FeesFromJSON,
    FeesFromJSONTyped,
    FeesToJSON,
} from './Fees';

/**
 * Contains info about current recommended fees for a transaction on both L1 and L2
 * @export
 * @interface BaseGasFees
 */
export interface BaseGasFees {
    /**
     * 
     * @type {string}
     * @memberof BaseGasFees
     */
    baseFeePerGas?: string;
    /**
     * 
     * @type {Fees}
     * @memberof BaseGasFees
     */
    slow: Fees;
    /**
     * 
     * @type {Fees}
     * @memberof BaseGasFees
     */
    average: Fees;
    /**
     * 
     * @type {Fees}
     * @memberof BaseGasFees
     */
    fast: Fees;
    /**
     * 
     * @type {string}
     * @memberof BaseGasFees
     */
    l1GasPrice: string;
}

/**
 * Check if a given object implements the BaseGasFees interface.
 */
export function instanceOfBaseGasFees(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "slow" in value;
    isInstance = isInstance && "average" in value;
    isInstance = isInstance && "fast" in value;
    isInstance = isInstance && "l1GasPrice" in value;

    return isInstance;
}

export function BaseGasFeesFromJSON(json: any): BaseGasFees {
    return BaseGasFeesFromJSONTyped(json, false);
}

export function BaseGasFeesFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseGasFees {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'baseFeePerGas': !exists(json, 'baseFeePerGas') ? undefined : json['baseFeePerGas'],
        'slow': FeesFromJSON(json['slow']),
        'average': FeesFromJSON(json['average']),
        'fast': FeesFromJSON(json['fast']),
        'l1GasPrice': json['l1GasPrice'],
    };
}

export function BaseGasFeesToJSON(value?: BaseGasFees | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'baseFeePerGas': value.baseFeePerGas,
        'slow': FeesToJSON(value.slow),
        'average': FeesToJSON(value.average),
        'fast': FeesToJSON(value.fast),
        'l1GasPrice': value.l1GasPrice,
    };
}

